import React from 'react';
import { useTranslation } from 'react-i18next';

// slice 02.1 · paso b — presentacional. El popover de recurrencia del panel de detalle de
// tarea (era JSX inline en `ComponentTaskHoy`). El contenedor mantiene el estado temporal
// (`interval`/`unit`) y el `onSave`; acá solo se pinta y se emiten los cambios.
export const RecurrencePopover = ({ interval, unit, onIntervalChange, onUnitChange, onSave }) => {
    const { t: translate } = useTranslation('tasks');

    return (
        <div
            className="calendly-glass-popover"
            onClick={(e) => e.stopPropagation()}
            style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: 'var(--space-1)',
                padding: 'var(--space-3)',
                zIndex: 2000,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                minWidth: '200px'
            }}
        >
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#fff' }}>{translate('modal.recurrencePopoverTitle')}</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '11px', color: '#888' }}>{translate('modal.recurrenceEveryLabel')}</span>
                <input
                    type="number"
                    aria-label={translate('modal.recurrenceIntervalAria')}
                    value={interval}
                    onChange={(e) => onIntervalChange(parseInt(e.target.value) || 0)}
                    style={{ width: '50px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: 'var(--radius-sm)', padding: 'var(--space-1)' }}
                />
                <select
                    value={unit}
                    onChange={(e) => onUnitChange(e.target.value)}
                    aria-label={translate('modal.recurrenceUnitAria')}
                    style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: 'var(--radius-sm)', padding: 'var(--space-1)', flexGrow: 1 }}
                >
                    <option value="dias">{translate('modal.recurrenceUnits.dias')}</option>
                    <option value="weeks">{translate('modal.recurrenceUnits.weeks')}</option>
                    <option value="meses">{translate('modal.recurrenceUnits.meses')}</option>
                    <option value="años">{translate('modal.recurrenceUnits.años')}</option>
                </select>
            </div>
            <button className="calendly-save-btn" onClick={onSave}>
                {translate('modal.save')}
            </button>
        </div>
    );
};

export default RecurrencePopover;
